import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled/box';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip/Tooltip';

import { useSearchMode } from './useSearchMode';

const styles = cssMap({
	inline: {
		display: 'inline-block',
	},
	inactive: {
		opacity: token('opacity.disabled'),
		filter: 'grayscale(1)',
		pointerEvents: 'none',
	},
});

/** Preserve the rich node and its geometry while explaining its Search semantics. */
export const SearchInactiveContent = ({
	children,
	as = 'span',
}: {
	children: React.ReactNode;
	as?: 'span' | 'div';
}): React.JSX.Element => {
	const searchMode = useSearchMode();
	return (
		<Tooltip content={searchMode?.unavailableMessage} position="top">
			{(tooltipProps) => (
				<Box
					{...tooltipProps}
					as={as}
					xcss={searchMode && as === 'span' ? styles.inline : undefined}
					role={searchMode ? 'group' : undefined}
					aria-label={searchMode?.unavailableMessage}
					aria-disabled={searchMode ? true : undefined}
					tabIndex={searchMode?.unavailableMessage ? 0 : undefined}
				>
					<Box as={as} xcss={searchMode ? styles.inactive : undefined}>
						{children}
					</Box>
				</Box>
			)}
		</Tooltip>
	);
};
